/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Crazylister's eBay module API
 * Crazylister's eBay module API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "https://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * Activity metadata
 * @export
 * @interface ActivityMetaData
 */
export interface ActivityMetaData {
    /**
     * Type of source data for the activity
     * @type {string}
     * @memberof ActivityMetaData
     */
    sourceType: string;
    /**
     * Name of the source for the activity
     * @type {string}
     * @memberof ActivityMetaData
     */
    sourceName: string;
    /**
     * Task identifier to update progress
     * @type {string}
     * @memberof ActivityMetaData
     */
    task: string;
    /**
     * Additional data for generic use
     * @type {any}
     * @memberof ActivityMetaData
     */
    additionalData?: any;
    /**
     * List of identifiers to refresh when there is progress in the activity
     * @type {Array&lt;string&gt;}
     * @memberof ActivityMetaData
     */
    refresh?: Array<string>;
}

/**
 * Get product id of listing
 * @export
 * @interface AlertStockSyncPauseParams
 */
export interface AlertStockSyncPauseParams {
    /**
     * seller id of listing
     * @type {string}
     * @memberof AlertStockSyncPauseParams
     */
    sellerId?: string;
    /**
     * item id of listing
     * @type {string}
     * @memberof AlertStockSyncPauseParams
     */
    channel?: string;
}

/**
 * Crazylister related amazon listing data - AmazonListing entity
 * @export
 * @interface AmazonListing
 */
export interface AmazonListing {
    /**
     * The listing's status
     * @type {string}
     * @memberof AmazonListing
     */
    amazonStatusFilter?: AmazonListing.AmazonStatusFilterEnum;
}

/**
 * @export
 * @namespace AmazonListing
 */
export namespace AmazonListing {
    /**
     * @export
     * @enum {string}
     */
    export enum AmazonStatusFilterEnum {
        Active = <any> 'Active',
        Inactive = <any> 'Inactive'
    }
}

/**
 * The request body for most listing actions
 * @export
 * @interface AmazonListingsApiRequestBody
 */
export interface AmazonListingsApiRequestBody {
    /**
     * Listing data that applies to all listings in the 'objects' parameter. If a key appears both here and in a listing from 'objects', the 'objects' listing's value is used
     * @type {any}
     * @memberof AmazonListingsApiRequestBody
     */
    baseObject?: any;
    /**
     * An array of listings. For a specific listing passed here, if a key appears both in this listing and in the baseObject, the value in this listings will be used
     * @type {Array&lt;any&gt;}
     * @memberof AmazonListingsApiRequestBody
     */
    objects: Array<any>;
    /**
     * site id
     * @type {string}
     * @memberof AmazonListingsApiRequestBody
     */
    site: string;
}

/**
 * Amazon seller entity
 * @export
 * @interface AmazonSeller
 */
export interface AmazonSeller {
    /**
     * The account id in Amazon
     * @type {string}
     * @memberof AmazonSeller
     */
    amazonSellerId?: string;
    /**
     * The account's name in Crazylister
     * @type {string}
     * @memberof AmazonSeller
     */
    name?: string;
    /**
     * Is quantity sync activated
     * @type {boolean}
     * @memberof AmazonSeller
     */
    quantitySyncEnabled?: boolean;
}

/**
 * 
 * @export
 * @interface Body
 */
export interface Body {
    /**
     * Activity metadata
     * @type {ActivityMetaData}
     * @memberof Body
     */
    activityMeta?: ActivityMetaData;
    /**
     * Container hold metadata regarding products
     * @type {any}
     * @memberof Body
     */
    importProps?: any;
}

/**
 * The request body for getting products
 * @export
 * @interface Body1
 */
export interface Body1 {
    /**
     * Array of objects
     * @type {Array&lt;SearchProductIdParams&gt;}
     * @memberof Body1
     */
    objects?: Array<SearchProductIdParams>;
}

/**
 * The request body for creating custom attributes
 * @export
 * @interface Body2
 */
export interface Body2 {
    /**
     * Array of create-attribute objects
     * @type {Array&lt;CreateAttributeParams&gt;}
     * @memberof Body2
     */
    attributes?: Array<CreateAttributeParams>;
}

/**
 * Channel enum, eBay or Amazon
 * @export
 * @enum {string}
 */
export enum Channels {
    Amazon = <any> 'Amazon',
    EBay = <any> 'eBay'
}

/**
 * Create custom attribute params
 * @export
 * @interface CreateAttributeParams
 */
export interface CreateAttributeParams {
    /**
     * display name of the custom attribute
     * @type {string}
     * @memberof CreateAttributeParams
     */
    displayName: string;
    /**
     * type of custom attribute
     * @type {string}
     * @memberof CreateAttributeParams
     */
    type: string;
    /**
     * section of the custom attribute
     * @type {string}
     * @memberof CreateAttributeParams
     */
    section: string;
}

/**
 * The request body for creating products
 * @export
 * @interface CreateFromAmazonCsvBody
 */
export interface CreateFromAmazonCsvBody {
    /**
     * CSV content
     * @type {string}
     * @memberof CreateFromAmazonCsvBody
     */
    content: string;
    /**
     * Activity metadata
     * @type {ActivityMetaData}
     * @memberof CreateFromAmazonCsvBody
     */
    activityMeta: ActivityMetaData;
}

/**
 * The request body for creating products
 * @export
 * @interface CreateFromListingsBody
 */
export interface CreateFromListingsBody {
    /**
     * Array of objects
     * @type {Array&lt;CreateLinkProductParams&gt;}
     * @memberof CreateFromListingsBody
     */
    objects: Array<CreateLinkProductParams>;
}

/**
 * Link/Unlink product to listing
 * @export
 * @interface CreateLinkProductParams
 */
export interface CreateLinkProductParams {
    /**
     * Channel - eBay/Amazon
     * @type {Channels}
     * @memberof CreateLinkProductParams
     */
    channel: Channels;
    /**
     * Listing SKU
     * @type {string}
     * @memberof CreateLinkProductParams
     */
    listingSKU?: string;
    /**
     * Product SKU
     * @type {string}
     * @memberof CreateLinkProductParams
     */
    SKU?: string;
    /**
     * Listing id
     * @type {string}
     * @memberof CreateLinkProductParams
     */
    listingId: string;
    /**
     * Seller id
     * @type {string}
     * @memberof CreateLinkProductParams
     */
    sellerId: string;
    /**
     * Listing variations link data, used for creating products from listings
     * @type {Array&lt;CreateLinkProductParams&gt;}
     * @memberof CreateLinkProductParams
     */
    variations?: Array<CreateLinkProductParams>;
}

/**
 * The request body for creating products
 * @export
 * @interface CreateProductsBody
 */
export interface CreateProductsBody {
    /**
     * Array of objects
     * @type {Array&lt;any&gt;}
     * @memberof CreateProductsBody
     */
    objects: Array<any>;
    /**
     * Options
     * @type {CreateUpdateProductOptions}
     * @memberof CreateProductsBody
     */
    options: CreateUpdateProductOptions;
    /**
     * if set true request will be handled syncroniously
     * @type {boolean}
     * @memberof CreateProductsBody
     */
    sync?: boolean;
    /**
     * Activity metadata
     * @type {ActivityMetaData}
     * @memberof CreateProductsBody
     */
    activityMeta?: ActivityMetaData;
}

/**
 * Activity metadata
 * @export
 * @interface CreateUpdateProductOptions
 */
export interface CreateUpdateProductOptions {
    /**
     * true - update existing product, false - ignore existing products
     * @type {boolean}
     * @memberof CreateUpdateProductOptions
     */
    updateExisting: boolean;
    /**
     * Update only empty product attributes
     * @type {boolean}
     * @memberof CreateUpdateProductOptions
     */
    updateOnlyEmptyAttributes?: boolean;
    /**
     * Ignore blank attributes in the source CSV (applicable only if updateOnlyEmptyAttributes=true)
     * @type {boolean}
     * @memberof CreateUpdateProductOptions
     */
    ignoreBlankAttributes?: boolean;
    /**
     * Replace images (default is to add images)
     * @type {boolean}
     * @memberof CreateUpdateProductOptions
     */
    replaceImages?: boolean;
}

/**
 * Custom propertiy name prefixes
 * @export
 * @enum {string}
 */
export enum CustomPropertyPrefix {
    Keyword = <any> 'cl-keyword',
    Long = <any> 'cl-long',
    Float = <any> 'cl-float'
}

/**
 * Delete attributes params
 * @export
 * @interface DeleteAttributesParams
 */
export interface DeleteAttributesParams {
    /**
     * attribute names to delete
     * @type {Array&lt;string&gt;}
     * @memberof DeleteAttributesParams
     */
    attributeNames: Array<string>;
}

/**
 * The request body of the duplicate action
 * @export
 * @interface DuplicateRequestBody
 */
export interface DuplicateRequestBody {
    /**
     * The seller that will be connected to the newly created drafts. If not given will use the source listing/draft seller
     * @type {string}
     * @memberof DuplicateRequestBody
     */
    destinationSellerId?: string;
    /**
     * An array of listings/drafts ids to duplicate
     * @type {Array&lt;string&gt;}
     * @memberof DuplicateRequestBody
     */
    itemsIds: Array<string>;
    /**
     * If true, copy the eBay images of the items to the new drafts
     * @type {boolean}
     * @memberof DuplicateRequestBody
     */
    copyImages?: boolean;
    /**
     * If true, copy the description of the items to the new drafts
     * @type {boolean}
     * @memberof DuplicateRequestBody
     */
    copyDescription?: boolean;
}

/**
 * 
 * @export
 * @interface ESQueryParams
 */
export interface ESQueryParams {
    /**
     * From index
     * @type {number}
     * @memberof ESQueryParams
     */
    from?: number;
    /**
     * Number of objects to retrieve
     * @type {number}
     * @memberof ESQueryParams
     */
    size?: number;
    /**
     * Sort params
     * @type {Array&lt;any&gt;}
     * @memberof ESQueryParams
     */
    sort?: Array<any>;
    /**
     * Query params
     * @type {any}
     * @memberof ESQueryParams
     */
    query?: any;
    /**
     * Options
     * @type {any}
     * @memberof ESQueryParams
     */
    options?: any;
}

/**
 * Crazylister related listing data - EbayListing entity
 * @export
 * @interface EbayListing
 */
export interface EbayListing {
    /**
     * The listing's ID
     * @type {string}
     * @memberof EbayListing
     */
    itemID?: string;
    /**
     * The id of the listing's seller
     * @type {string}
     * @memberof EbayListing
     */
    sellerId?: string;
    /**
     * The product's title
     * @type {string}
     * @memberof EbayListing
     */
    title?: string;
    /**
     * The listing's title on eBay
     * @type {string}
     * @memberof EbayListing
     */
    ebayTitle?: string;
    /**
     * The URLs of the pictures used in the listing's CL gallery
     * @type {Array&lt;string&gt;}
     * @memberof EbayListing
     */
    pictureURLs?: Array<string>;
    /**
     * The site of the listing
     * @type {string}
     * @memberof EbayListing
     */
    site?: string;
    /**
     * The product's description
     * @type {string}
     * @memberof EbayListing
     */
    description?: string;
    /**
     * The listing's revise status
     * @type {number}
     * @memberof EbayListing
     */
    reviseStatus?: number;
    /**
     * The id of the template used in the listing's description
     * @type {string}
     * @memberof EbayListing
     */
    templateId?: string;
    /**
     * The id of the template that was used in the last failed revise
     * @type {string}
     * @memberof EbayListing
     */
    lastFailedTemplateId?: string;
    /**
     * Id of the product associated with the listing
     * @type {string}
     * @memberof EbayListing
     */
    productId?: string;
    /**
     * The name of the listing's template
     * @type {string}
     * @memberof EbayListing
     */
    templateName?: string;
    /**
     * The listing's status
     * @type {string}
     * @memberof EbayListing
     */
    statusFilter?: EbayListing.StatusFilterEnum;
}

/**
 * @export
 * @namespace EbayListing
 */
export namespace EbayListing {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusFilterEnum {
        Active = <any> 'Active',
        Draft = <any> 'Draft',
        Ended = <any> 'Ended',
        Scheduled = <any> 'Scheduled'
    }
}

/**
 * 
 * @export
 * @interface EbayListingModel
 */
export interface EbayListingModel {
    /**
     * Crazylister related listing data - EbayListing entity
     * @type {EbayListing}
     * @memberof EbayListingModel
     */
    clData?: EbayListing;
    /**
     * The fields to delete from the eBay item
     * @type {any}
     * @memberof EbayListingModel
     */
    fieldsToDelete?: any;
    /**
     * Remove CrazyLister template
     * @type {boolean}
     * @memberof EbayListingModel
     */
    revertToOriginal?: boolean;
    /**
     * Revert the listing's description to its original state before CL templates were applied
     * @type {boolean}
     * @memberof EbayListingModel
     */
    restoreDesign?: boolean;
    /**
     * An object that maps the listing or its variations SKUs to the products they were created from in order to link them
     * @type {any}
     * @memberof EbayListingModel
     */
    skuToProductMapping?: any;
}

/**
 * 
 * @export
 * @interface EbayListingResponse
 */
export interface EbayListingResponse {
    /**
     * Crazylister related listing data - EbayListing entity
     * @type {EbayListing}
     * @memberof EbayListingResponse
     */
    updatedListings?: EbayListing;
    /**
     * Error array for each listing
     * @type {ErrorDetails}
     * @memberof EbayListingResponse
     */
    errors?: ErrorDetails;
    /**
     * indicated weather the request is async or not
     * @type {boolean}
     * @memberof EbayListingResponse
     */
    async?: boolean;
}

/**
 * 
 * @export
 * @interface ErrorDetails
 */
export interface ErrorDetails {
    /**
     * Error message
     * @type {string}
     * @memberof ErrorDetails
     */
    message?: string;
    /**
     * The failed action
     * @type {string}
     * @memberof ErrorDetails
     */
    action?: ErrorDetails.ActionEnum;
}

/**
 * @export
 * @namespace ErrorDetails
 */
export namespace ErrorDetails {
    /**
     * @export
     * @enum {string}
     */
    export enum ActionEnum {
        Revise = <any> 'Revise',
        Duplication = <any> 'Duplication'
    }
}

/**
 * Get product id of listing response
 * @export
 * @interface FindProductsByItemsResponse
 */
export interface FindProductsByItemsResponse {
    /**
     * seller id of listing
     * @type {string}
     * @memberof FindProductsByItemsResponse
     */
    sellerId: string;
    /**
     * item id of listing
     * @type {string}
     * @memberof FindProductsByItemsResponse
     */
    itemId: string;
    /**
     * sku of the listing
     * @type {string}
     * @memberof FindProductsByItemsResponse
     */
    SKU: string;
    /**
     * product linked to the listing
     * @type {any}
     * @memberof FindProductsByItemsResponse
     */
    product: any;
}

/**
 * The request body for sync product listings
 * @export
 * @interface GetProductListingsBody
 */
export interface GetProductListingsBody {
    /**
     * Product ids
     * @type {Array&lt;string&gt;}
     * @memberof GetProductListingsBody
     */
    productIds: Array<string>;
}

/**
 * The request body for getting products
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * Array of objects
     * @type {Array&lt;FindProductsByItemsResponse&gt;}
     * @memberof InlineResponse200
     */
    products?: Array<FindProductsByItemsResponse>;
}

/**
 * Get is paid feature enabled
 * @export
 * @interface IsPaidFeatureEnabledParams
 */
export interface IsPaidFeatureEnabledParams {
    /**
     * paid feature type
     * @type {string}
     * @memberof IsPaidFeatureEnabledParams
     */
    paidFeatureType: string;
}

/**
 * The request body for most listing actions
 * @export
 * @interface ListingsApiRequestBody
 */
export interface ListingsApiRequestBody {
    /**
     * Listing data that applies to all listings in the 'objects' parameter. If a key appears both here and in a listing from 'objects', the 'objects' listing's value is used
     * @type {EbayListingModel}
     * @memberof ListingsApiRequestBody
     */
    baseObject?: EbayListingModel;
    /**
     * An array of listings. For a specific listing passed here, if a key appears both in this listing and in the baseObject, the value in this listings will be used
     * @type {Array&lt;EbayListingModel&gt;}
     * @memberof ListingsApiRequestBody
     */
    objects: Array<EbayListingModel>;
    /**
     * Options for listingsApiRequest
     * @type {ListingsApiRequestOptions}
     * @memberof ListingsApiRequestBody
     */
    options?: ListingsApiRequestOptions;
}

/**
 * 
 * @export
 * @interface ListingsApiRequestOptions
 */
export interface ListingsApiRequestOptions {
    /**
     * Force sync/async behavior for the request
     * @type {boolean}
     * @memberof ListingsApiRequestOptions
     */
    async?: boolean;
    /**
     * Determines if the corresponding request enables retry
     * @type {boolean}
     * @memberof ListingsApiRequestOptions
     */
    allowRetry?: boolean;
    /**
     * Ending reason code for End Item request
     * @type {string}
     * @memberof ListingsApiRequestOptions
     */
    endingReason?: ListingsApiRequestOptions.EndingReasonEnum;
    /**
     * Activity metadata
     * @type {ActivityMetaData}
     * @memberof ListingsApiRequestOptions
     */
    activityMeta?: ActivityMetaData;
}

/**
 * @export
 * @namespace ListingsApiRequestOptions
 */
export namespace ListingsApiRequestOptions {
    /**
     * @export
     * @enum {string}
     */
    export enum EndingReasonEnum {
        Incorrect = <any> 'Incorrect',
        LostOrBroken = <any> 'LostOrBroken',
        NotAvailable = <any> 'NotAvailable',
        OtherListingError = <any> 'OtherListingError',
        SellToHighBidder = <any> 'SellToHighBidder',
        Sold = <any> 'Sold'
    }
}

/**
 * The request body for setting listings links
 * @export
 * @interface ListingsLinkBody
 */
export interface ListingsLinkBody {
    /**
     * Array of objects
     * @type {Array&lt;CreateLinkProductParams&gt;}
     * @memberof ListingsLinkBody
     */
    objects: Array<CreateLinkProductParams>;
}

/**
 * Metadata types
 * @export
 * @enum {string}
 */
export enum MetaDataTypes {
    SavedCategoryMapping = <any> 'savedCategoryMapping',
    CustomProperties = <any> 'customProperties'
}

/**
 * Get product id of listing
 * @export
 * @interface SearchProductIdParams
 */
export interface SearchProductIdParams {
    /**
     * seller id of listing
     * @type {string}
     * @memberof SearchProductIdParams
     */
    sellerId: string;
    /**
     * item id of listing
     * @type {string}
     * @memberof SearchProductIdParams
     */
    itemId?: string;
    /**
     * sku of the listing
     * @type {string}
     * @memberof SearchProductIdParams
     */
    SKU?: string;
}

/**
 * The keys used in the sku to product mapping object when syncing ebay listings in ES
 * @export
 * @enum {string}
 */
export enum SkuToProductMappingKeys {
    RegularListing = <any> 'regularListing',
    VariationsListings = <any> 'variationsListings'
}

/**
 * The request body for syncing ebay listings
 * @export
 * @interface SyncESListingsBody
 */
export interface SyncESListingsBody {
    /**
     * The ids of the listings to sync
     * @type {Array&lt;string&gt;}
     * @memberof SyncESListingsBody
     */
    itemsIds: Array<string>;
    /**
     * An object that maps each listing and variation SKU to the products they were created from in order to link them
     * @type {any}
     * @memberof SyncESListingsBody
     */
    skuToProductMapping?: any;
}

/**
 * The request body for sync product listings
 * @export
 * @interface SyncProductListingsBody
 */
export interface SyncProductListingsBody {
    /**
     * Product ids
     * @type {Array&lt;string&gt;}
     * @memberof SyncProductListingsBody
     */
    productIds: Array<string>;
    /**
     * Activity metadata
     * @type {ActivityMetaData}
     * @memberof SyncProductListingsBody
     */
    activityMeta?: ActivityMetaData;
}

/**
 * The names of CL tables, used mainly for refresh
 * @export
 * @enum {string}
 */
export enum Tables {
    EbayListingsTable = <any> 'ebayListingsTable',
    AmazonListingsTable = <any> 'amazonListingsTable',
    InventoryTable = <any> 'inventoryTable',
    PublishToEbayTable = <any> 'publishToEbayTable',
    PublishToAmazonTable = <any> 'publishToAmazonTable',
    InventoryManagementTable = <any> 'inventoryManagementTable',
    ImportTable = <any> 'importTable',
    FindCatalogTable = <any> 'findCatalogTable',
    AttributesTable = <any> 'attributesTable'
}

/**
 * Update attributes params
 * @export
 * @interface UpdateAttributesParams
 */
export interface UpdateAttributesParams {
    /**
     * the column to update
     * @type {string}
     * @memberof UpdateAttributesParams
     */
    column?: string;
    /**
     * the new value
     * @type {string}
     * @memberof UpdateAttributesParams
     */
    value?: string;
    /**
     * custom attribute names
     * @type {Array&lt;string&gt;}
     * @memberof UpdateAttributesParams
     */
    names?: Array<string>;
}

/**
 * The request body for updating a product
 * @export
 * @interface UpdateProductBody
 */
export interface UpdateProductBody {
    /**
     * Product data
     * @type {any}
     * @memberof UpdateProductBody
     */
    product: any;
    /**
     * Update product request options
     * @type {any}
     * @memberof UpdateProductBody
     */
    options?: any;
    /**
     * Activity metadata
     * @type {ActivityMetaData}
     * @memberof UpdateProductBody
     */
    activityMeta?: ActivityMetaData;
}

/**
 * 
 * @export
 * @interface UpdateProductsParams
 */
export interface UpdateProductsParams {
    /**
     * Query params
     * @type {any}
     * @memberof UpdateProductsParams
     */
    query: any;
    /**
     * Key value object of fields to change
     * @type {any}
     * @memberof UpdateProductsParams
     */
    update: any;
    /**
     * bulk update options
     * @type {any}
     * @memberof UpdateProductsParams
     */
    options?: any;
}

/**
 * Update seller quantity sync enabled params
 * @export
 * @interface UpdateSellerQuantitySyncEnabledParams
 */
export interface UpdateSellerQuantitySyncEnabledParams {
    /**
     * enable/disable quantity sync for seller
     * @type {boolean}
     * @memberof UpdateSellerQuantitySyncEnabledParams
     */
    quantitySyncEnabled: boolean;
    /**
     * id of the seller
     * @type {string}
     * @memberof UpdateSellerQuantitySyncEnabledParams
     */
    sellerId: string;
    /**
     * Channel - eBay/Amazon
     * @type {Channels}
     * @memberof UpdateSellerQuantitySyncEnabledParams
     */
    channel: Channels;
}


/**
 * ActivityLogApi - fetch parameter creator
 * @export
 */
export const ActivityLogApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Abort activities by query
         * @param {any} query Elasticsearch query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortActivities(query: any, options: any = {}): FetchArgs {
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new RequiredError('query','Required parameter query was null or undefined when calling abortActivities.');
            }
            const localVarPath = `activity-log/abort`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(query || {}) : (query || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get activity log entries
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLog(body: ESQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling getActivityLog.');
            }
            const localVarPath = `activity-log/get-activity-log`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ESQueryParams" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get activity log info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogColumns(options: any = {}): FetchArgs {
            const localVarPath = `activity-log`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'OPTIONS' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityLogApi - functional programming interface
 * @export
 */
export const ActivityLogApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Abort activities by query
         * @param {any} query Elasticsearch query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortActivities(query: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ActivityLogApiFetchParamCreator(configuration).abortActivities(query, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get activity log entries
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLog(body: ESQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ActivityLogApiFetchParamCreator(configuration).getActivityLog(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get activity log info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogColumns(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ActivityLogApiFetchParamCreator(configuration).getActivityLogColumns(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ActivityLogApi - factory interface
 * @export
 */
export const ActivityLogApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Abort activities by query
         * @param {any} query Elasticsearch query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortActivities(query: any, options?: any) {
            return ActivityLogApiFp(configuration).abortActivities(query, options)(fetch, basePath);
        },
        /**
         * Get activity log entries
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLog(body: ESQueryParams, options?: any) {
            return ActivityLogApiFp(configuration).getActivityLog(body, options)(fetch, basePath);
        },
        /**
         * Get activity log info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogColumns(options?: any) {
            return ActivityLogApiFp(configuration).getActivityLogColumns(options)(fetch, basePath);
        },
    };
};

/**
 * ActivityLogApi - object-oriented interface
 * @export
 * @class ActivityLogApi
 * @extends {BaseAPI}
 */
export class ActivityLogApi extends BaseAPI {
    /**
     * Abort activities by query
     * @param {} query Elasticsearch query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public abortActivities(query: any, options?: any) {
        return ActivityLogApiFp(this.configuration).abortActivities(query, options)(this.fetch, this.basePath);
    }

    /**
     * Get activity log entries
     * @param {} body Elasticsearch query params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public getActivityLog(body: ESQueryParams, options?: any) {
        return ActivityLogApiFp(this.configuration).getActivityLog(body, options)(this.fetch, this.basePath);
    }

    /**
     * Get activity log info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public getActivityLogColumns(options?: any) {
        return ActivityLogApiFp(this.configuration).getActivityLogColumns(options)(this.fetch, this.basePath);
    }

}

/**
 * AmazonAccountsApi - fetch parameter creator
 * @export
 */
export const AmazonAccountsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Disconnect the Amazon account from its user
         * @param {string} sellerId The ID of the amazon seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectAmazonAccount(sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling disconnectAmazonAccount.');
            }
            const localVarPath = `amazon-accounts/{seller-id}`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the Amazon account
         * @param {string} sellerId The ID of the amazon seller
         * @param {AmazonSeller} body The body of the request. Contains the Amazon seller entity fields defined in AmazonSeller.php
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAmazonAccount(sellerId: string, body: AmazonSeller, options: any = {}): FetchArgs {
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling updateAmazonAccount.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateAmazonAccount.');
            }
            const localVarPath = `amazon-accounts/{seller-id}`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AmazonSeller" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AmazonAccountsApi - functional programming interface
 * @export
 */
export const AmazonAccountsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Disconnect the Amazon account from its user
         * @param {string} sellerId The ID of the amazon seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectAmazonAccount(sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AmazonAccountsApiFetchParamCreator(configuration).disconnectAmazonAccount(sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update the Amazon account
         * @param {string} sellerId The ID of the amazon seller
         * @param {AmazonSeller} body The body of the request. Contains the Amazon seller entity fields defined in AmazonSeller.php
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAmazonAccount(sellerId: string, body: AmazonSeller, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AmazonAccountsApiFetchParamCreator(configuration).updateAmazonAccount(sellerId, body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AmazonAccountsApi - factory interface
 * @export
 */
export const AmazonAccountsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Disconnect the Amazon account from its user
         * @param {string} sellerId The ID of the amazon seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectAmazonAccount(sellerId: string, options?: any) {
            return AmazonAccountsApiFp(configuration).disconnectAmazonAccount(sellerId, options)(fetch, basePath);
        },
        /**
         * Update the Amazon account
         * @param {string} sellerId The ID of the amazon seller
         * @param {AmazonSeller} body The body of the request. Contains the Amazon seller entity fields defined in AmazonSeller.php
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAmazonAccount(sellerId: string, body: AmazonSeller, options?: any) {
            return AmazonAccountsApiFp(configuration).updateAmazonAccount(sellerId, body, options)(fetch, basePath);
        },
    };
};

/**
 * AmazonAccountsApi - object-oriented interface
 * @export
 * @class AmazonAccountsApi
 * @extends {BaseAPI}
 */
export class AmazonAccountsApi extends BaseAPI {
    /**
     * Disconnect the Amazon account from its user
     * @param {} sellerId The ID of the amazon seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmazonAccountsApi
     */
    public disconnectAmazonAccount(sellerId: string, options?: any) {
        return AmazonAccountsApiFp(this.configuration).disconnectAmazonAccount(sellerId, options)(this.fetch, this.basePath);
    }

    /**
     * Update the Amazon account
     * @param {} sellerId The ID of the amazon seller
     * @param {} body The body of the request. Contains the Amazon seller entity fields defined in AmazonSeller.php
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmazonAccountsApi
     */
    public updateAmazonAccount(sellerId: string, body: AmazonSeller, options?: any) {
        return AmazonAccountsApiFp(this.configuration).updateAmazonAccount(sellerId, body, options)(this.fetch, this.basePath);
    }

}

/**
 * AmazonListingsApi - fetch parameter creator
 * @export
 */
export const AmazonListingsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new listings
         * @param {AmazonListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewListing(body: AmazonListingsApiRequestBody, sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createNewListing.');
            }
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling createNewListing.');
            }
            const localVarPath = `amazon-sellers/{seller-id}/amazon-listings`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AmazonListingsApiRequestBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sellerId The ID of the seller
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {string} [statusFilter] Filters the results to return only the listings with the given status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings(sellerId: string, body: ESQueryParams, statusFilter?: string, options: any = {}): FetchArgs {
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling getListings.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling getListings.');
            }
            const localVarPath = `amazon-sellers/{seller-id}/amazon-listings/get-listings`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (statusFilter !== undefined) {
                localVarQueryParameter['statusFilter'] = statusFilter;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ESQueryParams" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the columns and counts per status filter for the amazon listings table
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsColumns(sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling getListingsColumns.');
            }
            const localVarPath = `amazon-sellers/{seller-id}/amazon-listings`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'OPTIONS' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Counts the amount of listings the seller has per status filter
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsCount(sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling getListingsCount.');
            }
            const localVarPath = `amazon-sellers/{seller-id}/amazon-listings/count`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Synchronizes seller's listings from amazon
         * @param {string} sellerId The ID of the seller
         * @param {Body} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncListings(sellerId: string, body: Body, options: any = {}): FetchArgs {
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling syncListings.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling syncListings.');
            }
            const localVarPath = `amazon-sellers/{seller-id}/amazon-listings/sync`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Body" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AmazonListingsApi - functional programming interface
 * @export
 */
export const AmazonListingsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create new listings
         * @param {AmazonListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewListing(body: AmazonListingsApiRequestBody, sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AmazonListingsApiFetchParamCreator(configuration).createNewListing(body, sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} sellerId The ID of the seller
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {string} [statusFilter] Filters the results to return only the listings with the given status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings(sellerId: string, body: ESQueryParams, statusFilter?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AmazonListingsApiFetchParamCreator(configuration).getListings(sellerId, body, statusFilter, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the columns and counts per status filter for the amazon listings table
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsColumns(sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AmazonListingsApiFetchParamCreator(configuration).getListingsColumns(sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Counts the amount of listings the seller has per status filter
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsCount(sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AmazonListingsApiFetchParamCreator(configuration).getListingsCount(sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Synchronizes seller's listings from amazon
         * @param {string} sellerId The ID of the seller
         * @param {Body} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncListings(sellerId: string, body: Body, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AmazonListingsApiFetchParamCreator(configuration).syncListings(sellerId, body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AmazonListingsApi - factory interface
 * @export
 */
export const AmazonListingsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Create new listings
         * @param {AmazonListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewListing(body: AmazonListingsApiRequestBody, sellerId: string, options?: any) {
            return AmazonListingsApiFp(configuration).createNewListing(body, sellerId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} sellerId The ID of the seller
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {string} [statusFilter] Filters the results to return only the listings with the given status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings(sellerId: string, body: ESQueryParams, statusFilter?: string, options?: any) {
            return AmazonListingsApiFp(configuration).getListings(sellerId, body, statusFilter, options)(fetch, basePath);
        },
        /**
         * Returns the columns and counts per status filter for the amazon listings table
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsColumns(sellerId: string, options?: any) {
            return AmazonListingsApiFp(configuration).getListingsColumns(sellerId, options)(fetch, basePath);
        },
        /**
         * Counts the amount of listings the seller has per status filter
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsCount(sellerId: string, options?: any) {
            return AmazonListingsApiFp(configuration).getListingsCount(sellerId, options)(fetch, basePath);
        },
        /**
         * Synchronizes seller's listings from amazon
         * @param {string} sellerId The ID of the seller
         * @param {Body} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncListings(sellerId: string, body: Body, options?: any) {
            return AmazonListingsApiFp(configuration).syncListings(sellerId, body, options)(fetch, basePath);
        },
    };
};

/**
 * AmazonListingsApi - object-oriented interface
 * @export
 * @class AmazonListingsApi
 * @extends {BaseAPI}
 */
export class AmazonListingsApi extends BaseAPI {
    /**
     * Create new listings
     * @param {} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
     * @param {} sellerId The ID of the seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmazonListingsApi
     */
    public createNewListing(body: AmazonListingsApiRequestBody, sellerId: string, options?: any) {
        return AmazonListingsApiFp(this.configuration).createNewListing(body, sellerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {} sellerId The ID of the seller
     * @param {} body Elasticsearch query params
     * @param {} [statusFilter] Filters the results to return only the listings with the given status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmazonListingsApi
     */
    public getListings(sellerId: string, body: ESQueryParams, statusFilter?: string, options?: any) {
        return AmazonListingsApiFp(this.configuration).getListings(sellerId, body, statusFilter, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the columns and counts per status filter for the amazon listings table
     * @param {} sellerId The ID of the seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmazonListingsApi
     */
    public getListingsColumns(sellerId: string, options?: any) {
        return AmazonListingsApiFp(this.configuration).getListingsColumns(sellerId, options)(this.fetch, this.basePath);
    }

    /**
     * Counts the amount of listings the seller has per status filter
     * @param {} sellerId The ID of the seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmazonListingsApi
     */
    public getListingsCount(sellerId: string, options?: any) {
        return AmazonListingsApiFp(this.configuration).getListingsCount(sellerId, options)(this.fetch, this.basePath);
    }

    /**
     * Synchronizes seller's listings from amazon
     * @param {} sellerId The ID of the seller
     * @param {} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmazonListingsApi
     */
    public syncListings(sellerId: string, body: Body, options?: any) {
        return AmazonListingsApiFp(this.configuration).syncListings(sellerId, body, options)(this.fetch, this.basePath);
    }

}

/**
 * AttributesApi - fetch parameter creator
 * @export
 */
export const AttributesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * create attributes
         * @param {Body2} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttributes(body: Body2, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAttributes.');
            }
            const localVarPath = `user/attributes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Body2" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete attributes
         * @param {DeleteAttributesParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttributes(body: DeleteAttributesParams, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling deleteAttributes.');
            }
            const localVarPath = `user/attributes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DeleteAttributesParams" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the columns for the attributes table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributesColumns(options: any = {}): FetchArgs {
            const localVarPath = `user/attributes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'OPTIONS' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user attributes by key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAttributes(options: any = {}): FetchArgs {
            const localVarPath = `user/attributes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update attributes
         * @param {UpdateAttributesParams} body update attributes params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttributes(body: UpdateAttributesParams, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateAttributes.');
            }
            const localVarPath = `user/attributes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateAttributesParams" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttributesApi - functional programming interface
 * @export
 */
export const AttributesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * create attributes
         * @param {Body2} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttributes(body: Body2, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AttributesApiFetchParamCreator(configuration).createAttributes(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * delete attributes
         * @param {DeleteAttributesParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttributes(body: DeleteAttributesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AttributesApiFetchParamCreator(configuration).deleteAttributes(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the columns for the attributes table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributesColumns(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AttributesApiFetchParamCreator(configuration).getAttributesColumns(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get user attributes by key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAttributes(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AttributesApiFetchParamCreator(configuration).getUserAttributes(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * update attributes
         * @param {UpdateAttributesParams} body update attributes params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttributes(body: UpdateAttributesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AttributesApiFetchParamCreator(configuration).updateAttributes(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AttributesApi - factory interface
 * @export
 */
export const AttributesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * create attributes
         * @param {Body2} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttributes(body: Body2, options?: any) {
            return AttributesApiFp(configuration).createAttributes(body, options)(fetch, basePath);
        },
        /**
         * delete attributes
         * @param {DeleteAttributesParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttributes(body: DeleteAttributesParams, options?: any) {
            return AttributesApiFp(configuration).deleteAttributes(body, options)(fetch, basePath);
        },
        /**
         * Returns the columns for the attributes table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributesColumns(options?: any) {
            return AttributesApiFp(configuration).getAttributesColumns(options)(fetch, basePath);
        },
        /**
         * Get user attributes by key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAttributes(options?: any) {
            return AttributesApiFp(configuration).getUserAttributes(options)(fetch, basePath);
        },
        /**
         * update attributes
         * @param {UpdateAttributesParams} body update attributes params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttributes(body: UpdateAttributesParams, options?: any) {
            return AttributesApiFp(configuration).updateAttributes(body, options)(fetch, basePath);
        },
    };
};

/**
 * AttributesApi - object-oriented interface
 * @export
 * @class AttributesApi
 * @extends {BaseAPI}
 */
export class AttributesApi extends BaseAPI {
    /**
     * create attributes
     * @param {} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    public createAttributes(body: Body2, options?: any) {
        return AttributesApiFp(this.configuration).createAttributes(body, options)(this.fetch, this.basePath);
    }

    /**
     * delete attributes
     * @param {} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    public deleteAttributes(body: DeleteAttributesParams, options?: any) {
        return AttributesApiFp(this.configuration).deleteAttributes(body, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the columns for the attributes table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    public getAttributesColumns(options?: any) {
        return AttributesApiFp(this.configuration).getAttributesColumns(options)(this.fetch, this.basePath);
    }

    /**
     * Get user attributes by key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    public getUserAttributes(options?: any) {
        return AttributesApiFp(this.configuration).getUserAttributes(options)(this.fetch, this.basePath);
    }

    /**
     * update attributes
     * @param {} body update attributes params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    public updateAttributes(body: UpdateAttributesParams, options?: any) {
        return AttributesApiFp(this.configuration).updateAttributes(body, options)(this.fetch, this.basePath);
    }

}

/**
 * ConfigApi - fetch parameter creator
 * @export
 */
export const ConfigApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get user config by key
         * @param {string} key config key (alphanumeric and .\\-_ only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(key: string, options: any = {}): FetchArgs {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling getConfig.');
            }
            const localVarPath = `config/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigApi - functional programming interface
 * @export
 */
export const ConfigApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get user config by key
         * @param {string} key config key (alphanumeric and .\\-_ only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(key: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ConfigApiFetchParamCreator(configuration).getConfig(key, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ConfigApi - factory interface
 * @export
 */
export const ConfigApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get user config by key
         * @param {string} key config key (alphanumeric and .\\-_ only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(key: string, options?: any) {
            return ConfigApiFp(configuration).getConfig(key, options)(fetch, basePath);
        },
    };
};

/**
 * ConfigApi - object-oriented interface
 * @export
 * @class ConfigApi
 * @extends {BaseAPI}
 */
export class ConfigApi extends BaseAPI {
    /**
     * Get user config by key
     * @param {} key config key (alphanumeric and .\\-_ only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public getConfig(key: string, options?: any) {
        return ConfigApiFp(this.configuration).getConfig(key, options)(this.fetch, this.basePath);
    }

}

/**
 * EbayApi - fetch parameter creator
 * @export
 */
export const EbayApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [site] The ebay site we wish to get the details about
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEbayDetails(site?: string, options: any = {}): FetchArgs {
            const localVarPath = `ebay/ebay/get-ebay-details`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (site !== undefined) {
                localVarQueryParameter['site'] = site;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EbayApi - functional programming interface
 * @export
 */
export const EbayApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [site] The ebay site we wish to get the details about
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEbayDetails(site?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = EbayApiFetchParamCreator(configuration).getEbayDetails(site, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * EbayApi - factory interface
 * @export
 */
export const EbayApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} [site] The ebay site we wish to get the details about
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEbayDetails(site?: string, options?: any) {
            return EbayApiFp(configuration).getEbayDetails(site, options)(fetch, basePath);
        },
    };
};

/**
 * EbayApi - object-oriented interface
 * @export
 * @class EbayApi
 * @extends {BaseAPI}
 */
export class EbayApi extends BaseAPI {
    /**
     * 
     * @param {} [site] The ebay site we wish to get the details about
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EbayApi
     */
    public getEbayDetails(site?: string, options?: any) {
        return EbayApiFp(this.configuration).getEbayDetails(site, options)(this.fetch, this.basePath);
    }

}

/**
 * EbayProductsApi - fetch parameter creator
 * @export
 */
export const EbayProductsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} epid 
         * @param {string} site 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEbayProduct(epid: string, site: string, options: any = {}): FetchArgs {
            // verify required parameter 'epid' is not null or undefined
            if (epid === null || epid === undefined) {
                throw new RequiredError('epid','Required parameter epid was null or undefined when calling getEbayProduct.');
            }
            // verify required parameter 'site' is not null or undefined
            if (site === null || site === undefined) {
                throw new RequiredError('site','Required parameter site was null or undefined when calling getEbayProduct.');
            }
            const localVarPath = `ebay-products/{epid}`
                .replace(`{${"epid"}}`, encodeURIComponent(String(epid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (site !== undefined) {
                localVarQueryParameter['site'] = site;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [categoryId] The category in which to perform the search
         * @param {string} [query] The search query to send to the API
         * @param {string} [site] The site to send to the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEbayProducts(categoryId?: string, query?: string, site?: string, options: any = {}): FetchArgs {
            const localVarPath = `ebay-products`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (site !== undefined) {
                localVarQueryParameter['site'] = site;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EbayProductsApi - functional programming interface
 * @export
 */
export const EbayProductsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} epid 
         * @param {string} site 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEbayProduct(epid: string, site: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EbayProductsApiFetchParamCreator(configuration).getEbayProduct(epid, site, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [categoryId] The category in which to perform the search
         * @param {string} [query] The search query to send to the API
         * @param {string} [site] The site to send to the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEbayProducts(categoryId?: string, query?: string, site?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EbayProductsApiFetchParamCreator(configuration).getEbayProducts(categoryId, query, site, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * EbayProductsApi - factory interface
 * @export
 */
export const EbayProductsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} epid 
         * @param {string} site 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEbayProduct(epid: string, site: string, options?: any) {
            return EbayProductsApiFp(configuration).getEbayProduct(epid, site, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [categoryId] The category in which to perform the search
         * @param {string} [query] The search query to send to the API
         * @param {string} [site] The site to send to the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEbayProducts(categoryId?: string, query?: string, site?: string, options?: any) {
            return EbayProductsApiFp(configuration).getEbayProducts(categoryId, query, site, options)(fetch, basePath);
        },
    };
};

/**
 * EbayProductsApi - object-oriented interface
 * @export
 * @class EbayProductsApi
 * @extends {BaseAPI}
 */
export class EbayProductsApi extends BaseAPI {
    /**
     * 
     * @param {} epid 
     * @param {} site 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EbayProductsApi
     */
    public getEbayProduct(epid: string, site: string, options?: any) {
        return EbayProductsApiFp(this.configuration).getEbayProduct(epid, site, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {} [categoryId] The category in which to perform the search
     * @param {} [query] The search query to send to the API
     * @param {} [site] The site to send to the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EbayProductsApi
     */
    public getEbayProducts(categoryId?: string, query?: string, site?: string, options?: any) {
        return EbayProductsApiFp(this.configuration).getEbayProducts(categoryId, query, site, options)(this.fetch, this.basePath);
    }

}

/**
 * ListingsApi - fetch parameter creator
 * @export
 */
export const ListingsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new listing
         * @param {ListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewListing(body: ListingsApiRequestBody, sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createNewListing.');
            }
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling createNewListing.');
            }
            const localVarPath = `sellers/{seller-id}/listings`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ListingsApiRequestBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates drafts from the given listings/drafts ids
         * @param {DuplicateRequestBody} body The body of the request. Defined in Definitions/duplicateRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateListings(body: DuplicateRequestBody, sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling duplicateListings.');
            }
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling duplicateListings.');
            }
            const localVarPath = `sellers/{seller-id}/listings/duplicate`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DuplicateRequestBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sellerId The ID of the seller
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {string} [statusFilter] Filters the results to return only the listings with the given status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings(sellerId: string, body: ESQueryParams, statusFilter?: string, options: any = {}): FetchArgs {
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling getListings.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling getListings.');
            }
            const localVarPath = `sellers/{seller-id}/listings/get-listings`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (statusFilter !== undefined) {
                localVarQueryParameter['statusFilter'] = statusFilter;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ESQueryParams" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the columns and counts per status filter for the listings table
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsColumns(sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling getListingsColumns.');
            }
            const localVarPath = `sellers/{seller-id}/listings`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'OPTIONS' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Counts the amount of listings the seller has per status filter
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsCount(sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling getListingsCount.');
            }
            const localVarPath = `sellers/{seller-id}/listings/count`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * saves existing draft
         * @param {ListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDraft(body: ListingsApiRequestBody, sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling saveDraft.');
            }
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling saveDraft.');
            }
            const localVarPath = `sellers/{seller-id}/listings`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ListingsApiRequestBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Syncs the Ebay listings in ES of the given ids
         * @param {SyncESListingsBody} syncESListingsBody The body of the request
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncESListings(syncESListingsBody: SyncESListingsBody, sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'syncESListingsBody' is not null or undefined
            if (syncESListingsBody === null || syncESListingsBody === undefined) {
                throw new RequiredError('syncESListingsBody','Required parameter syncESListingsBody was null or undefined when calling syncESListings.');
            }
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling syncESListings.');
            }
            const localVarPath = `sellers/{seller-id}/listings/sync`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("x-cl-api-key")
					: configuration.apiKey;
                localVarHeaderParameter["x-cl-api-key"] = localVarApiKeyValue;
            }

            // authentication userId required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("x-cl-user-id")
					: configuration.apiKey;
                localVarHeaderParameter["x-cl-user-id"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SyncESListingsBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(syncESListingsBody || {}) : (syncESListingsBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the seller's listings/Drafts. If the listing status is Active, it revises it on eBay.
         * @param {ListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateListings(body: ListingsApiRequestBody, sellerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateListings.');
            }
            // verify required parameter 'sellerId' is not null or undefined
            if (sellerId === null || sellerId === undefined) {
                throw new RequiredError('sellerId','Required parameter sellerId was null or undefined when calling updateListings.');
            }
            const localVarPath = `sellers/{seller-id}/listings`
                .replace(`{${"seller-id"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ListingsApiRequestBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListingsApi - functional programming interface
 * @export
 */
export const ListingsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Creates a new listing
         * @param {ListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewListing(body: ListingsApiRequestBody, sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ListingsApiFetchParamCreator(configuration).createNewListing(body, sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates drafts from the given listings/drafts ids
         * @param {DuplicateRequestBody} body The body of the request. Defined in Definitions/duplicateRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateListings(body: DuplicateRequestBody, sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ListingsApiFetchParamCreator(configuration).duplicateListings(body, sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} sellerId The ID of the seller
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {string} [statusFilter] Filters the results to return only the listings with the given status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings(sellerId: string, body: ESQueryParams, statusFilter?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ListingsApiFetchParamCreator(configuration).getListings(sellerId, body, statusFilter, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the columns and counts per status filter for the listings table
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsColumns(sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ListingsApiFetchParamCreator(configuration).getListingsColumns(sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Counts the amount of listings the seller has per status filter
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsCount(sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ListingsApiFetchParamCreator(configuration).getListingsCount(sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * saves existing draft
         * @param {ListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDraft(body: ListingsApiRequestBody, sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ListingsApiFetchParamCreator(configuration).saveDraft(body, sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Syncs the Ebay listings in ES of the given ids
         * @param {SyncESListingsBody} syncESListingsBody The body of the request
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncESListings(syncESListingsBody: SyncESListingsBody, sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ListingsApiFetchParamCreator(configuration).syncESListings(syncESListingsBody, sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Updates the seller's listings/Drafts. If the listing status is Active, it revises it on eBay.
         * @param {ListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateListings(body: ListingsApiRequestBody, sellerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ListingsApiFetchParamCreator(configuration).updateListings(body, sellerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ListingsApi - factory interface
 * @export
 */
export const ListingsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Creates a new listing
         * @param {ListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewListing(body: ListingsApiRequestBody, sellerId: string, options?: any) {
            return ListingsApiFp(configuration).createNewListing(body, sellerId, options)(fetch, basePath);
        },
        /**
         * Creates drafts from the given listings/drafts ids
         * @param {DuplicateRequestBody} body The body of the request. Defined in Definitions/duplicateRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateListings(body: DuplicateRequestBody, sellerId: string, options?: any) {
            return ListingsApiFp(configuration).duplicateListings(body, sellerId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} sellerId The ID of the seller
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {string} [statusFilter] Filters the results to return only the listings with the given status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings(sellerId: string, body: ESQueryParams, statusFilter?: string, options?: any) {
            return ListingsApiFp(configuration).getListings(sellerId, body, statusFilter, options)(fetch, basePath);
        },
        /**
         * Returns the columns and counts per status filter for the listings table
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsColumns(sellerId: string, options?: any) {
            return ListingsApiFp(configuration).getListingsColumns(sellerId, options)(fetch, basePath);
        },
        /**
         * Counts the amount of listings the seller has per status filter
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsCount(sellerId: string, options?: any) {
            return ListingsApiFp(configuration).getListingsCount(sellerId, options)(fetch, basePath);
        },
        /**
         * saves existing draft
         * @param {ListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDraft(body: ListingsApiRequestBody, sellerId: string, options?: any) {
            return ListingsApiFp(configuration).saveDraft(body, sellerId, options)(fetch, basePath);
        },
        /**
         * Syncs the Ebay listings in ES of the given ids
         * @param {SyncESListingsBody} syncESListingsBody The body of the request
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncESListings(syncESListingsBody: SyncESListingsBody, sellerId: string, options?: any) {
            return ListingsApiFp(configuration).syncESListings(syncESListingsBody, sellerId, options)(fetch, basePath);
        },
        /**
         * Updates the seller's listings/Drafts. If the listing status is Active, it revises it on eBay.
         * @param {ListingsApiRequestBody} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
         * @param {string} sellerId The ID of the seller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateListings(body: ListingsApiRequestBody, sellerId: string, options?: any) {
            return ListingsApiFp(configuration).updateListings(body, sellerId, options)(fetch, basePath);
        },
    };
};

/**
 * ListingsApi - object-oriented interface
 * @export
 * @class ListingsApi
 * @extends {BaseAPI}
 */
export class ListingsApi extends BaseAPI {
    /**
     * Creates a new listing
     * @param {} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
     * @param {} sellerId The ID of the seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListingsApi
     */
    public createNewListing(body: ListingsApiRequestBody, sellerId: string, options?: any) {
        return ListingsApiFp(this.configuration).createNewListing(body, sellerId, options)(this.fetch, this.basePath);
    }

    /**
     * Creates drafts from the given listings/drafts ids
     * @param {} body The body of the request. Defined in Definitions/duplicateRequestBody in Swagger.php
     * @param {} sellerId The ID of the seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListingsApi
     */
    public duplicateListings(body: DuplicateRequestBody, sellerId: string, options?: any) {
        return ListingsApiFp(this.configuration).duplicateListings(body, sellerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {} sellerId The ID of the seller
     * @param {} body Elasticsearch query params
     * @param {} [statusFilter] Filters the results to return only the listings with the given status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListingsApi
     */
    public getListings(sellerId: string, body: ESQueryParams, statusFilter?: string, options?: any) {
        return ListingsApiFp(this.configuration).getListings(sellerId, body, statusFilter, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the columns and counts per status filter for the listings table
     * @param {} sellerId The ID of the seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListingsApi
     */
    public getListingsColumns(sellerId: string, options?: any) {
        return ListingsApiFp(this.configuration).getListingsColumns(sellerId, options)(this.fetch, this.basePath);
    }

    /**
     * Counts the amount of listings the seller has per status filter
     * @param {} sellerId The ID of the seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListingsApi
     */
    public getListingsCount(sellerId: string, options?: any) {
        return ListingsApiFp(this.configuration).getListingsCount(sellerId, options)(this.fetch, this.basePath);
    }

    /**
     * saves existing draft
     * @param {} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
     * @param {} sellerId The ID of the seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListingsApi
     */
    public saveDraft(body: ListingsApiRequestBody, sellerId: string, options?: any) {
        return ListingsApiFp(this.configuration).saveDraft(body, sellerId, options)(this.fetch, this.basePath);
    }

    /**
     * Syncs the Ebay listings in ES of the given ids
     * @param {} syncESListingsBody The body of the request
     * @param {} sellerId The ID of the seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListingsApi
     */
    public syncESListings(syncESListingsBody: SyncESListingsBody, sellerId: string, options?: any) {
        return ListingsApiFp(this.configuration).syncESListings(syncESListingsBody, sellerId, options)(this.fetch, this.basePath);
    }

    /**
     * Updates the seller's listings/Drafts. If the listing status is Active, it revises it on eBay.
     * @param {} body The body of the request. Defined in Definitions/ListingsApiRequestBody in Swagger.php
     * @param {} sellerId The ID of the seller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListingsApi
     */
    public updateListings(body: ListingsApiRequestBody, sellerId: string, options?: any) {
        return ListingsApiFp(this.configuration).updateListings(body, sellerId, options)(this.fetch, this.basePath);
    }

}

/**
 * MetadataApi - fetch parameter creator
 * @export
 */
export const MetadataApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get user metadata by key
         * @param {string} key metadata key (alphanumeric and .\\-_ only)
         * @param {string} [metaDataType] 
         * @param {string} [additionalData] Additional request data for general use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMetadata(key: string, metaDataType?: string, additionalData?: string, options: any = {}): FetchArgs {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling getUserMetadata.');
            }
            const localVarPath = `user/metadata/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metaDataType !== undefined) {
                localVarQueryParameter['metaDataType'] = metaDataType;
            }

            if (additionalData !== undefined) {
                localVarQueryParameter['additionalData'] = additionalData;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user metadata by key prefix prefix
         * @param {string} prefix metadata key (alphanumeric and .\\-_ only)
         * @param {string} [metaDataType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMetadataByPrefix(prefix: string, metaDataType?: string, options: any = {}): FetchArgs {
            // verify required parameter 'prefix' is not null or undefined
            if (prefix === null || prefix === undefined) {
                throw new RequiredError('prefix','Required parameter prefix was null or undefined when calling getUserMetadataByPrefix.');
            }
            const localVarPath = `user/metadata`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (prefix !== undefined) {
                localVarQueryParameter['prefix'] = prefix;
            }

            if (metaDataType !== undefined) {
                localVarQueryParameter['metaDataType'] = metaDataType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * is paid feature enabled
         * @param {IsPaidFeatureEnabledParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isPaidFeatureEnabled(body: IsPaidFeatureEnabledParams, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling isPaidFeatureEnabled.');
            }
            const localVarPath = `user/metadata/is-paid-feature-enabled`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("x-cl-api-key")
					: configuration.apiKey;
                localVarHeaderParameter["x-cl-api-key"] = localVarApiKeyValue;
            }

            // authentication userId required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("x-cl-user-id")
					: configuration.apiKey;
                localVarHeaderParameter["x-cl-user-id"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"IsPaidFeatureEnabledParams" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user metadata by key
         * @param {string} key metadata key (alphanumeric and .\\-_ only)
         * @param {string} [metaDataType] 
         * @param {string} [value] value to store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserMetadata(key: string, metaDataType?: string, value?: string, options: any = {}): FetchArgs {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling setUserMetadata.');
            }
            const localVarPath = `user/metadata/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metaDataType !== undefined) {
                localVarQueryParameter['metaDataType'] = metaDataType;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(value || {}) : (value || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetadataApi - functional programming interface
 * @export
 */
export const MetadataApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get user metadata by key
         * @param {string} key metadata key (alphanumeric and .\\-_ only)
         * @param {string} [metaDataType] 
         * @param {string} [additionalData] Additional request data for general use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMetadata(key: string, metaDataType?: string, additionalData?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = MetadataApiFetchParamCreator(configuration).getUserMetadata(key, metaDataType, additionalData, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get user metadata by key prefix prefix
         * @param {string} prefix metadata key (alphanumeric and .\\-_ only)
         * @param {string} [metaDataType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMetadataByPrefix(prefix: string, metaDataType?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MetadataApiFetchParamCreator(configuration).getUserMetadataByPrefix(prefix, metaDataType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * is paid feature enabled
         * @param {IsPaidFeatureEnabledParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isPaidFeatureEnabled(body: IsPaidFeatureEnabledParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = MetadataApiFetchParamCreator(configuration).isPaidFeatureEnabled(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get user metadata by key
         * @param {string} key metadata key (alphanumeric and .\\-_ only)
         * @param {string} [metaDataType] 
         * @param {string} [value] value to store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserMetadata(key: string, metaDataType?: string, value?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MetadataApiFetchParamCreator(configuration).setUserMetadata(key, metaDataType, value, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MetadataApi - factory interface
 * @export
 */
export const MetadataApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get user metadata by key
         * @param {string} key metadata key (alphanumeric and .\\-_ only)
         * @param {string} [metaDataType] 
         * @param {string} [additionalData] Additional request data for general use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMetadata(key: string, metaDataType?: string, additionalData?: string, options?: any) {
            return MetadataApiFp(configuration).getUserMetadata(key, metaDataType, additionalData, options)(fetch, basePath);
        },
        /**
         * Get user metadata by key prefix prefix
         * @param {string} prefix metadata key (alphanumeric and .\\-_ only)
         * @param {string} [metaDataType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMetadataByPrefix(prefix: string, metaDataType?: string, options?: any) {
            return MetadataApiFp(configuration).getUserMetadataByPrefix(prefix, metaDataType, options)(fetch, basePath);
        },
        /**
         * is paid feature enabled
         * @param {IsPaidFeatureEnabledParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isPaidFeatureEnabled(body: IsPaidFeatureEnabledParams, options?: any) {
            return MetadataApiFp(configuration).isPaidFeatureEnabled(body, options)(fetch, basePath);
        },
        /**
         * Get user metadata by key
         * @param {string} key metadata key (alphanumeric and .\\-_ only)
         * @param {string} [metaDataType] 
         * @param {string} [value] value to store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserMetadata(key: string, metaDataType?: string, value?: string, options?: any) {
            return MetadataApiFp(configuration).setUserMetadata(key, metaDataType, value, options)(fetch, basePath);
        },
    };
};

/**
 * MetadataApi - object-oriented interface
 * @export
 * @class MetadataApi
 * @extends {BaseAPI}
 */
export class MetadataApi extends BaseAPI {
    /**
     * Get user metadata by key
     * @param {} key metadata key (alphanumeric and .\\-_ only)
     * @param {} [metaDataType] 
     * @param {} [additionalData] Additional request data for general use
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public getUserMetadata(key: string, metaDataType?: string, additionalData?: string, options?: any) {
        return MetadataApiFp(this.configuration).getUserMetadata(key, metaDataType, additionalData, options)(this.fetch, this.basePath);
    }

    /**
     * Get user metadata by key prefix prefix
     * @param {} prefix metadata key (alphanumeric and .\\-_ only)
     * @param {} [metaDataType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public getUserMetadataByPrefix(prefix: string, metaDataType?: string, options?: any) {
        return MetadataApiFp(this.configuration).getUserMetadataByPrefix(prefix, metaDataType, options)(this.fetch, this.basePath);
    }

    /**
     * is paid feature enabled
     * @param {} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public isPaidFeatureEnabled(body: IsPaidFeatureEnabledParams, options?: any) {
        return MetadataApiFp(this.configuration).isPaidFeatureEnabled(body, options)(this.fetch, this.basePath);
    }

    /**
     * Get user metadata by key
     * @param {} key metadata key (alphanumeric and .\\-_ only)
     * @param {} [metaDataType] 
     * @param {} [value] value to store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public setUserMetadata(key: string, metaDataType?: string, value?: string, options?: any) {
        return MetadataApiFp(this.configuration).setUserMetadata(key, metaDataType, value, options)(this.fetch, this.basePath);
    }

}

/**
 * ProductsApi - fetch parameter creator
 * @export
 */
export const ProductsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Alert the seller on his stock sync pause via email
         * @param {AlertStockSyncPauseParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertStockSyncPause(body: AlertStockSyncPauseParams, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling alertStockSyncPause.');
            }
            const localVarPath = `products/alert-stock-sync-pause`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("x-cl-api-key")
					: configuration.apiKey;
                localVarHeaderParameter["x-cl-api-key"] = localVarApiKeyValue;
            }

            // authentication userId required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("x-cl-user-id")
					: configuration.apiKey;
                localVarHeaderParameter["x-cl-user-id"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AlertStockSyncPauseParams" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get products
         * @param {CreateFromAmazonCsvBody} createFromAmazonCsvBody Any file containing product info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromAmazonCsv(createFromAmazonCsvBody: CreateFromAmazonCsvBody, options: any = {}): FetchArgs {
            // verify required parameter 'createFromAmazonCsvBody' is not null or undefined
            if (createFromAmazonCsvBody === null || createFromAmazonCsvBody === undefined) {
                throw new RequiredError('createFromAmazonCsvBody','Required parameter createFromAmazonCsvBody was null or undefined when calling createFromAmazonCsv.');
            }
            const localVarPath = `products/create-from-amazon-csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateFromAmazonCsvBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(createFromAmazonCsvBody || {}) : (createFromAmazonCsvBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create products from listings
         * @param {CreateFromListingsBody} createFromListingsBody The body of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromListings(createFromListingsBody: CreateFromListingsBody, options: any = {}): FetchArgs {
            // verify required parameter 'createFromListingsBody' is not null or undefined
            if (createFromListingsBody === null || createFromListingsBody === undefined) {
                throw new RequiredError('createFromListingsBody','Required parameter createFromListingsBody was null or undefined when calling createFromListings.');
            }
            const localVarPath = `products/create-from-listings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateFromListingsBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(createFromListingsBody || {}) : (createFromListingsBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates new products
         * @param {CreateProductsBody} createProductsBody The body of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateProducts(createProductsBody: CreateProductsBody, options: any = {}): FetchArgs {
            // verify required parameter 'createProductsBody' is not null or undefined
            if (createProductsBody === null || createProductsBody === undefined) {
                throw new RequiredError('createProductsBody','Required parameter createProductsBody was null or undefined when calling createUpdateProducts.');
            }
            const localVarPath = `products`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("x-cl-api-key")
					: configuration.apiKey;
                localVarHeaderParameter["x-cl-api-key"] = localVarApiKeyValue;
            }

            // authentication userId required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("x-cl-user-id")
					: configuration.apiKey;
                localVarHeaderParameter["x-cl-user-id"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateProductsBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(createProductsBody || {}) : (createProductsBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete products
         * @param {any} [query] Elasticsearch query params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProducts(query?: any, options: any = {}): FetchArgs {
            const localVarPath = `products`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(query || {}) : (query || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get products by seller id, item id and sku
         * @param {Body1} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProductsByItems(body: Body1, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling findProductsByItems.');
            }
            const localVarPath = `products/find-products-by-items`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("x-cl-api-key")
					: configuration.apiKey;
                localVarHeaderParameter["x-cl-api-key"] = localVarApiKeyValue;
            }

            // authentication userId required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("x-cl-user-id")
					: configuration.apiKey;
                localVarHeaderParameter["x-cl-user-id"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Body1" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product listings
         * @param {GetProductListingsBody} body request data body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListings(body: GetProductListingsBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling getProductListings.');
            }
            const localVarPath = `products/get-product-listings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GetProductListingsBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product schema info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSchemaInfo(options: any = {}): FetchArgs {
            const localVarPath = `products`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'OPTIONS' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get products
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(body: ESQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling getProducts.');
            }
            const localVarPath = `products/get-products`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ESQueryParams" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or unset listing link
         * @param {ListingsLinkBody} listingsLinkBody The body of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setListingsLink(listingsLinkBody: ListingsLinkBody, options: any = {}): FetchArgs {
            // verify required parameter 'listingsLinkBody' is not null or undefined
            if (listingsLinkBody === null || listingsLinkBody === undefined) {
                throw new RequiredError('listingsLinkBody','Required parameter listingsLinkBody was null or undefined when calling setListingsLink.');
            }
            const localVarPath = `products/set-listings-link`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ListingsLinkBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(listingsLinkBody || {}) : (listingsLinkBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync product listings
         * @param {SyncProductListingsBody} body request data body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncProductListings(body: SyncProductListingsBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling syncProductListings.');
            }
            const localVarPath = `products/sync-product-listings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SyncProductListingsBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update product
         * @param {string} id The id of the product
         * @param {UpdateProductBody} body request data body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(id: string, body: UpdateProductBody, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateProduct.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateProduct.');
            }
            const localVarPath = `products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateProductBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update existing product
         * @param {UpdateProductsParams} updateProductsParams Update products request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProducts(updateProductsParams: UpdateProductsParams, options: any = {}): FetchArgs {
            // verify required parameter 'updateProductsParams' is not null or undefined
            if (updateProductsParams === null || updateProductsParams === undefined) {
                throw new RequiredError('updateProductsParams','Required parameter updateProductsParams was null or undefined when calling updateProducts.');
            }
            const localVarPath = `products`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateProductsParams" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateProductsParams || {}) : (updateProductsParams || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update seller quantity sync enabled
         * @param {UpdateSellerQuantitySyncEnabledParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSellerQuantitySyncEnabled(body: UpdateSellerQuantitySyncEnabledParams, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateSellerQuantitySyncEnabled.');
            }
            const localVarPath = `products/update-seller-quantity-sync-enabled`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateSellerQuantitySyncEnabledParams" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Alert the seller on his stock sync pause via email
         * @param {AlertStockSyncPauseParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertStockSyncPause(body: AlertStockSyncPauseParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).alertStockSyncPause(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get products
         * @param {CreateFromAmazonCsvBody} createFromAmazonCsvBody Any file containing product info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromAmazonCsv(createFromAmazonCsvBody: CreateFromAmazonCsvBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).createFromAmazonCsv(createFromAmazonCsvBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create products from listings
         * @param {CreateFromListingsBody} createFromListingsBody The body of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromListings(createFromListingsBody: CreateFromListingsBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).createFromListings(createFromListingsBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates new products
         * @param {CreateProductsBody} createProductsBody The body of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateProducts(createProductsBody: CreateProductsBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).createUpdateProducts(createProductsBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Delete products
         * @param {any} [query] Elasticsearch query params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProducts(query?: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).deleteProducts(query, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * get products by seller id, item id and sku
         * @param {Body1} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProductsByItems(body: Body1, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).findProductsByItems(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get product listings
         * @param {GetProductListingsBody} body request data body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListings(body: GetProductListingsBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).getProductListings(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get product schema info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSchemaInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).getProductSchemaInfo(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get products
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(body: ESQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).getProducts(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Set or unset listing link
         * @param {ListingsLinkBody} listingsLinkBody The body of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setListingsLink(listingsLinkBody: ListingsLinkBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).setListingsLink(listingsLinkBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Sync product listings
         * @param {SyncProductListingsBody} body request data body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncProductListings(body: SyncProductListingsBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).syncProductListings(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update product
         * @param {string} id The id of the product
         * @param {UpdateProductBody} body request data body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(id: string, body: UpdateProductBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).updateProduct(id, body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update existing product
         * @param {UpdateProductsParams} updateProductsParams Update products request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProducts(updateProductsParams: UpdateProductsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).updateProducts(updateProductsParams, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update seller quantity sync enabled
         * @param {UpdateSellerQuantitySyncEnabledParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSellerQuantitySyncEnabled(body: UpdateSellerQuantitySyncEnabledParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).updateSellerQuantitySyncEnabled(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Alert the seller on his stock sync pause via email
         * @param {AlertStockSyncPauseParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertStockSyncPause(body: AlertStockSyncPauseParams, options?: any) {
            return ProductsApiFp(configuration).alertStockSyncPause(body, options)(fetch, basePath);
        },
        /**
         * Get products
         * @param {CreateFromAmazonCsvBody} createFromAmazonCsvBody Any file containing product info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromAmazonCsv(createFromAmazonCsvBody: CreateFromAmazonCsvBody, options?: any) {
            return ProductsApiFp(configuration).createFromAmazonCsv(createFromAmazonCsvBody, options)(fetch, basePath);
        },
        /**
         * Create products from listings
         * @param {CreateFromListingsBody} createFromListingsBody The body of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromListings(createFromListingsBody: CreateFromListingsBody, options?: any) {
            return ProductsApiFp(configuration).createFromListings(createFromListingsBody, options)(fetch, basePath);
        },
        /**
         * Creates new products
         * @param {CreateProductsBody} createProductsBody The body of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateProducts(createProductsBody: CreateProductsBody, options?: any) {
            return ProductsApiFp(configuration).createUpdateProducts(createProductsBody, options)(fetch, basePath);
        },
        /**
         * Delete products
         * @param {any} [query] Elasticsearch query params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProducts(query?: any, options?: any) {
            return ProductsApiFp(configuration).deleteProducts(query, options)(fetch, basePath);
        },
        /**
         * get products by seller id, item id and sku
         * @param {Body1} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProductsByItems(body: Body1, options?: any) {
            return ProductsApiFp(configuration).findProductsByItems(body, options)(fetch, basePath);
        },
        /**
         * Get product listings
         * @param {GetProductListingsBody} body request data body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListings(body: GetProductListingsBody, options?: any) {
            return ProductsApiFp(configuration).getProductListings(body, options)(fetch, basePath);
        },
        /**
         * Get product schema info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSchemaInfo(options?: any) {
            return ProductsApiFp(configuration).getProductSchemaInfo(options)(fetch, basePath);
        },
        /**
         * Get products
         * @param {ESQueryParams} body Elasticsearch query params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(body: ESQueryParams, options?: any) {
            return ProductsApiFp(configuration).getProducts(body, options)(fetch, basePath);
        },
        /**
         * Set or unset listing link
         * @param {ListingsLinkBody} listingsLinkBody The body of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setListingsLink(listingsLinkBody: ListingsLinkBody, options?: any) {
            return ProductsApiFp(configuration).setListingsLink(listingsLinkBody, options)(fetch, basePath);
        },
        /**
         * Sync product listings
         * @param {SyncProductListingsBody} body request data body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncProductListings(body: SyncProductListingsBody, options?: any) {
            return ProductsApiFp(configuration).syncProductListings(body, options)(fetch, basePath);
        },
        /**
         * Update product
         * @param {string} id The id of the product
         * @param {UpdateProductBody} body request data body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(id: string, body: UpdateProductBody, options?: any) {
            return ProductsApiFp(configuration).updateProduct(id, body, options)(fetch, basePath);
        },
        /**
         * Update existing product
         * @param {UpdateProductsParams} updateProductsParams Update products request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProducts(updateProductsParams: UpdateProductsParams, options?: any) {
            return ProductsApiFp(configuration).updateProducts(updateProductsParams, options)(fetch, basePath);
        },
        /**
         * Update seller quantity sync enabled
         * @param {UpdateSellerQuantitySyncEnabledParams} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSellerQuantitySyncEnabled(body: UpdateSellerQuantitySyncEnabledParams, options?: any) {
            return ProductsApiFp(configuration).updateSellerQuantitySyncEnabled(body, options)(fetch, basePath);
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * Alert the seller on his stock sync pause via email
     * @param {} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public alertStockSyncPause(body: AlertStockSyncPauseParams, options?: any) {
        return ProductsApiFp(this.configuration).alertStockSyncPause(body, options)(this.fetch, this.basePath);
    }

    /**
     * Get products
     * @param {} createFromAmazonCsvBody Any file containing product info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public createFromAmazonCsv(createFromAmazonCsvBody: CreateFromAmazonCsvBody, options?: any) {
        return ProductsApiFp(this.configuration).createFromAmazonCsv(createFromAmazonCsvBody, options)(this.fetch, this.basePath);
    }

    /**
     * Create products from listings
     * @param {} createFromListingsBody The body of the request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public createFromListings(createFromListingsBody: CreateFromListingsBody, options?: any) {
        return ProductsApiFp(this.configuration).createFromListings(createFromListingsBody, options)(this.fetch, this.basePath);
    }

    /**
     * Creates new products
     * @param {} createProductsBody The body of the request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public createUpdateProducts(createProductsBody: CreateProductsBody, options?: any) {
        return ProductsApiFp(this.configuration).createUpdateProducts(createProductsBody, options)(this.fetch, this.basePath);
    }

    /**
     * Delete products
     * @param {} [query] Elasticsearch query params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public deleteProducts(query?: any, options?: any) {
        return ProductsApiFp(this.configuration).deleteProducts(query, options)(this.fetch, this.basePath);
    }

    /**
     * get products by seller id, item id and sku
     * @param {} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public findProductsByItems(body: Body1, options?: any) {
        return ProductsApiFp(this.configuration).findProductsByItems(body, options)(this.fetch, this.basePath);
    }

    /**
     * Get product listings
     * @param {} body request data body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductListings(body: GetProductListingsBody, options?: any) {
        return ProductsApiFp(this.configuration).getProductListings(body, options)(this.fetch, this.basePath);
    }

    /**
     * Get product schema info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductSchemaInfo(options?: any) {
        return ProductsApiFp(this.configuration).getProductSchemaInfo(options)(this.fetch, this.basePath);
    }

    /**
     * Get products
     * @param {} body Elasticsearch query params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProducts(body: ESQueryParams, options?: any) {
        return ProductsApiFp(this.configuration).getProducts(body, options)(this.fetch, this.basePath);
    }

    /**
     * Set or unset listing link
     * @param {} listingsLinkBody The body of the request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public setListingsLink(listingsLinkBody: ListingsLinkBody, options?: any) {
        return ProductsApiFp(this.configuration).setListingsLink(listingsLinkBody, options)(this.fetch, this.basePath);
    }

    /**
     * Sync product listings
     * @param {} body request data body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public syncProductListings(body: SyncProductListingsBody, options?: any) {
        return ProductsApiFp(this.configuration).syncProductListings(body, options)(this.fetch, this.basePath);
    }

    /**
     * Update product
     * @param {} id The id of the product
     * @param {} body request data body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateProduct(id: string, body: UpdateProductBody, options?: any) {
        return ProductsApiFp(this.configuration).updateProduct(id, body, options)(this.fetch, this.basePath);
    }

    /**
     * Update existing product
     * @param {} updateProductsParams Update products request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateProducts(updateProductsParams: UpdateProductsParams, options?: any) {
        return ProductsApiFp(this.configuration).updateProducts(updateProductsParams, options)(this.fetch, this.basePath);
    }

    /**
     * Update seller quantity sync enabled
     * @param {} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateSellerQuantitySyncEnabled(body: UpdateSellerQuantitySyncEnabledParams, options?: any) {
        return ProductsApiFp(this.configuration).updateSellerQuantitySyncEnabled(body, options)(this.fetch, this.basePath);
    }

}

/**
 * UserApi - fetch parameter creator
 * @export
 */
export const UserApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get user invalid tokens seller ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvalidSellers(options: any = {}): FetchArgs {
            const localVarPath = `application/user/getInvalidSellers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get user invalid tokens seller ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvalidSellers(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).getInvalidSellers(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get user invalid tokens seller ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvalidSellers(options?: any) {
            return UserApiFp(configuration).getInvalidSellers(options)(fetch, basePath);
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Get user invalid tokens seller ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getInvalidSellers(options?: any) {
        return UserApiFp(this.configuration).getInvalidSellers(options)(this.fetch, this.basePath);
    }

}

